export default "__VITE_ASSET__Bdaf2DEH__"